export enum CreatePqrComponentMode {
    Create = 1,
    CreateAnonymous = 2
}